import { mergeAttributes, Node, } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import Component from "./Node.vue";
import { createDefaultBlockForTipTap } from "~/stores/mail-block-editor/defaults";

const Document = Node.create({
    name: "document",
    group: "block",
    content: "(section?)+",

    atom: true,
    defining: true,
    topNode: true,

    addAttributes() {
        return createDefaultBlockForTipTap("document");
    },

    parseHTML() {
        return [
            {
                tag: "document",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["html", ["body", mergeAttributes(HTMLAttributes), 0]];
    },

    addNodeView() {
        return VueNodeViewRenderer(Component);
    },
});

export default Document;
